"use strict";Object.defineProperty(exports,"__esModule",{value:!0});var a={base:{"::placeholder":{color:"#737c97",opacity:1}},invalid:{border:"1px solid #dc0d49",color:"#131e40"}};exports.default=a
//# sourceMappingURL=styles.js.map
